import {IMAGES} from "@assets";
export default {
    inserted(el, binding) {
        run(el, binding)
    },

    componentUpdated(el, binding) {
        // check if src changed
        if (el.__lastSrc !== el.getAttribute('src')) {
            run(el, binding)
        }
    }
}

function run(el, binding) {
    const settings = {
        loading: IMAGES.image_loading,
        error: IMAGES.image_loading,
        ...(binding.value || {})
    }

    // opt-out of the placeholder swap: keep the real src so an already
    // available image paints straight away instead of flashing the loading image
    const showLoading = Boolean(settings.loading)

    const baseSrc = el.getAttribute('src')
    if (!baseSrc) {
        if (showLoading) {
            el.src = settings.loading;
        }
        return;
    }

    // avoid multiple processing
    if (el.__processing) return
    el.__processing = true
    el.__lastSrc = baseSrc

    // set loading
    if (showLoading) {
        el.src = settings.loading
    }

    const mainImg = new Image()

    mainImg.onload = () => {
        el.src = baseSrc
        el.__processing = false
    }

    mainImg.onerror = () => {
        if (el.dataset.original !== undefined) {
            loadOriginal(el, baseSrc, settings)
        } else {
            el.src = settings.error
            el.__processing = false
        }
    }

    mainImg.src = baseSrc
}

function loadOriginal(el, baseSrc, settings) {
    const match = baseSrc.match(/\.([^.]*)$/)
    if (!match) {
        el.src = settings.error
        el.__processing = false
        return
    }

    const originalSrc = baseSrc.replace(/\.([^.]*)$/i, '_original.$1')
    const originalImg = new Image()

    originalImg.onload = () => {
        el.src = originalSrc
        el.__processing = false
    }

    originalImg.onerror = () => {
        el.src = settings.error
        el.__processing = false
    }

    originalImg.src = originalSrc
}
